<template>
    <div class="row-min-space">
        <b-form-group
            :label="field.label"
            :label-for="`id_${field._id}`"
            :class="{
                'required-field': field.isRequired,
            }"
        >
            <div class="row profile-setup">
                <div class="col-md-5 mb-20 dialling-code-field">
                    <isd-code
                        v-validate="{
                            required: true,
                        }"
                        :data-segment-id="dataSegmentId"
                        :field="{
                            association: 'countries',
                            type: 'isd-code',
                            isLocked: true,
                            isRequired: field.isRequired,
                            label: 'Dialing code',
                            placeholder: 'Dialing code',
                            options: [],
                            key: 'contactInfo.isdCode',
                        }"
                        text-field="isdCodeTitle"
                        value-field="isdCode"
                        :multiple="false"
                        name="Dialing Code"
                        :class="{
                            'is-invalid': errors.has('Dialing Code'),
                        }"
                    ></isd-code>
                </div>
                <div class="col-md-7">
                    <b-form-input
                        v-model="model"
                        v-validate="{
                            required: field.isRequired,
                            max: 15,
                            regex: /^([0-9]*)$/,
                        }"
                        type="text"
                        placeholder="Enter phone number"
                        data-vv-name="phone number"
                        :class="{
                            'is-invalid': errors.has('phone number'),
                        }"
                    ></b-form-input>
                </div>
            </div>
        </b-form-group>
    </div>
</template>

<script>
import TextField from './TextField'
import IsdCode from './IsdCode'
export default {
    // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        IsdCode,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: TextField, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {
        $validator: '$validator',
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            required: true,
        },
        dataSegmentId: {
            type: String,
            required: true,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            textField: 'title',
            valueField: '_id',
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {}, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {}, // End of Component > mounted
}
</script>
